import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';
import { getSurfaceBorder, getSurfaceColor, radii } from '../tokens';

export const styledBackstageTable = (
  theme: Theme,
): BackstageOverrides['BackstageTable'] => ({
  root: {
    backgroundColor: getSurfaceColor(theme, 'raised'),
    border: `1px solid ${getSurfaceBorder(theme)}`,
    borderRadius: radii.lg,
    boxShadow: 'none',
    maxWidth: '100%',
    overflow: 'hidden',
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
    '& thead tr > th, & tbody tr > td': {
      verticalAlign: 'middle',
    },
    '& tbody tr > td': {
      paddingBottom: theme.spacing(1.35),
      paddingTop: theme.spacing(1.35),
    },
    '& tbody tr > td [class*="CatalogReactEntityDisplayName-root"]': {
      alignItems: 'center',
      display: 'inline-flex',
      verticalAlign: 'middle',
    },
    '& tbody tr > td [class*="CatalogReactEntityDisplayName-icon"]': {
      alignItems: 'center',
      display: 'inline-flex',
      flexShrink: 0,
      lineHeight: 0,
    },
    '& tbody tr > td [class*="CatalogReactEntityDisplayName-icon"] svg': {
      display: 'block',
    },
  },
});
